import { BaseModel } from './base';

export class Option extends BaseModel {
    public editable: boolean;
    public headerVisible: boolean;
    public searchable: boolean;
    public sortable: boolean;

    constructor(json?: any) {
        super(json);
    }
}
